module.exports = __webpack_public_path__ + "img/EgyptTechPriestTrain1_ua.d2e61ca8.webp";